"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icons = require("../Icons");

var _renderprops = require("react-spring/renderprops");

var _styleModule = _interopRequireDefault(require("./style.module.css"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

var ModalContainer = function ModalContainer(_ref) {
  var children = _ref.children,
      close = _ref.close,
      mount = _ref.mount; //Component will mount

  (0, _react.useEffect)(function () {
    document.body.style.height = "100vh";
    document.body.style.width = "100vw";
    document.body.style.overflow = "hidden";
  }, []); //Component will unmount

  (0, _react.useEffect)(function () {
    return function () {
      document.body.style.height = "auto";
      document.body.style.width = "auto";
      document.body.style.overflow = "initial";
    };
  }, []);
  var mountID = mount || "modal-root";
  return (0, _reactDom.createPortal)(_react.default.createElement(_renderprops.Transition, {
    native: true,
    items: true,
    from: {
      opacity: 0
    },
    enter: {
      opacity: 1
    },
    leave: {
      opacity: 0
    }
  }, function (show) {
    return show && function (props) {
      return _react.default.createElement(_renderprops.animated.div, {
        style: props,
        className: _styleModule.default.container
      }, _react.default.createElement("div", {
        className: _styleModule.default.modalBody
      }, _react.default.createElement("div", {
        className: _styleModule.default.closeButton,
        onClick: close
      }, _react.default.createElement(_Icons.CrossIcon, {
        width: "1.25rem"
      })), _react.default.createElement("div", {
        className: _styleModule.default.bodyContainer
      }, children)));
    };
  }), document.getElementById(mountID));
};

ModalContainer.propTypes = {
  close: _propTypes.default.func.isRequired
};
var _default = ModalContainer;
exports.default = _default;